'use strict';

module.exports = [require('./erf')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/special/index.js
// module id = QSi6
// module chunks = 0